import { render, staticRenderFns } from "./sectionList.vue?vue&type=template&id=ef4d22dc&scoped=true&"
import script from "./sectionList.vue?vue&type=script&lang=js&"
export * from "./sectionList.vue?vue&type=script&lang=js&"
import style0 from "./sectionList.vue?vue&type=style&index=0&id=ef4d22dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d22dc",
  null
  
)

export default component.exports